import { useFilteredRoutes } from 'app/router/useFilteredRoutes';
import { privateRoutes } from './routesConfig';

import type { RouteConfig } from 'app/types/router';

/** Private routes of the edelvives router with tenant feature gating applied (see useFilteredRoutes). */
export function usePrivateRoutes(): RouteConfig[] {
  return useFilteredRoutes(privateRoutes);
}
